export class DashboardIdentificationModalCookie {
  private static readonly cookieName = 'dashboard_identify_modal_open'

  static store = () => {
    document.cookie = `${this.cookieName}=true;path=/;max-age=60`
  }

  static clear = () => {
    document.cookie = `${this.cookieName}=true;path=/;max-age=0`
  }
}
